<div class="topbar">
  <div>
    <h1>Indstillinger for varenumre</h1>
  </div>
  <div class="topbar__actions">
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret fabrikat">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret mapping</span>
      </button>
    }
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    <table mat-table [dataSource]="mappings" class="mat-elevation-z0 settings__table">
      <ng-container matColumnDef="partnerVarenr">
        <th mat-header-cell *matHeaderCellDef>Partner</th>
        <td mat-cell *matCellDef="let row">
          {{ row.partnerVarenr }}
        </td>
      </ng-container>
      <ng-container matColumnDef="okKundeVarenr">
        <th mat-header-cell *matHeaderCellDef>OK</th>
        <td mat-cell *matCellDef="let row">
          {{ row.okKundeVarenr }}
          @if (row.okKundeVarenrText) {
            <span>({{ row.okKundeVarenrText }})</span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="hidden-cell">
            @if (canEdit) {
              <button (click)="edit(row)" class="btn-icon blue" aria-label="Rediger varenr" matTooltip="Rediger varenr">
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
            }
            @if (canEdit) {
              <button (click)="delete(row)" class="btn-icon blue" aria-label="Slet varenr" matTooltip="Slet varenr">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            }
            <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
              <mat-icon>timeline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
